export const formatDate = (dateTime) => {
  if (!dateTime) return "Invalid Date";

  const date = new Date(dateTime);

  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  return date.toLocaleString();
};

export function formatDateToYYYY_MM_DD(date) {
  if (!(date instanceof Date) || isNaN(date)) {
    throw new Error("Invalid Date object passed to formatDateToString");
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
